import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const NECK_FORM_INITIAL_VALUES = {
  sections: {
    postpartumNeck: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamPerineumAndExternalGenitaliaSections =
  keyof typeof NECK_FORM_INITIAL_VALUES.sections;
